import { LANGUAGES } from "./index";
import type { Language } from "./types";

type SnippetConfig = {
  token: string;
  baseUrl?: string;
};

export function buildSnippets(
  snippetMap: Record<Language, (config: SnippetConfig) => string>,
  token: string,
  baseUrl = window.location.origin
) {
  return Object.fromEntries(
    LANGUAGES.map(({ value }) => [value, snippetMap[value]({ token, baseUrl })])
  ) as Record<Language, string>;
}
